import { IconSVG } from '../types';

export const Smartphone = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path d="M7.308 22.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V3.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h9.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v17.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H7.308zM7 17.77v2.922c0 .077.032.148.096.212a.294.294 0 00.212.096h9.384a.294.294 0 00.212-.096.294.294 0 00.096-.212V17.77H7zm5 2.5a.853.853 0 00.626-.26.853.853 0 00.259-.625.852.852 0 00-.26-.626A.852.852 0 0012 18.5a.853.853 0 00-.626.259.853.853 0 00-.259.626c0 .244.087.453.259.625a.853.853 0 00.626.26zm-5-4h10V5.75H7v10.52zM7 4.25h10v-.942a.294.294 0 00-.096-.212.294.294 0 00-.212-.096H7.308a.294.294 0 00-.212.096.294.294 0 00-.096.212v.942z" />
    </svg>
  );
};
